import Group from "./GroupContainer.vue";
import Text from "./Text.vue";

const GroupComponent = Object.assign({}, Group, {
  Text: Text,
});

export default GroupComponent;
